import { render, staticRenderFns } from "./SubscriptionExpansion.vue?vue&type=template&id=974a74e8&scoped=true&"
import script from "./SubscriptionExpansion.vue?vue&type=script&lang=js&"
export * from "./SubscriptionExpansion.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionExpansion.vue?vue&type=style&index=0&id=974a74e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974a74e8",
  null
  
)

export default component.exports